class AccordionBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.sections = block.querySelectorAll('.accordion-section');

    this.sections.forEach((section, i) => {
      const header = section.querySelector('.accordion-section__header');
      const content = section.querySelector('.accordion-section__content');

      let wrapper = this.createColumnWrapper();

      [...content.children].forEach((child) => {
        if (child.nodeName === 'HR') {
          content.removeChild(child);
          content.appendChild(wrapper);
          wrapper = this.createColumnWrapper();
        } else {
          wrapper.appendChild(child);
        }
      });

      content.append(wrapper);

      header.addEventListener('click', () => {
        this.sections.forEach((s) => {
          if (s !== section) {
            s.classList.remove('active');
            s.querySelector('.accordion-section__content').style.height = 0;
          }
        });

        section.classList.toggle('active');
        content.style.height = section.classList.contains('active') ? content.scrollHeight + 'px' : 0;
      });
    });

    window.addEventListener('resize', () => this.resize());

    this.block.querySelectorAll('img').forEach((img) => {
      img.addEventListener('load', () => this.resize());
    });
  }

  createColumnWrapper() {
    const wrapper = document.createElement('div');
    wrapper.classList.add('accordion-section__column');
    wrapper.classList.add('content');
    return wrapper;
  }

  resize() {
    this.sections.forEach((section) => {
      if (section.classList.contains('active')) {
        const content = section.querySelector('.accordion-section__content');
        content.style.transition = 'none';
        content.style.height = 0;
        content.offsetWidth;
        content.style.height = content.scrollHeight + 'px';
        content.offsetWidth;
        content.style.transition = null;
      }
    });
  }
}

// Initialize each block on page load (front end)
if (!window.acf) {
  document.querySelectorAll('.accordion').forEach((block) => {
    new AccordionBlock(block);
  });

  window.addEventListener('init', () => {
    document.querySelectorAll('.accordion').forEach((block) => {
      new AccordionBlock(block);
    });
  });
}